const navigationItems = [
  {
    id: 1,
    title: 'المنتجات',
    key: 'products',
    to: '/products',
    icon: { icon: 'mdi mdi-store' },
    subItems: []
  },
  {
    id: 2,
    title: 'التصنيفات',
    key: 'categories',
    to: '/categories',
    icon: { icon: 'mdi-sitemap-outline' },
    subItems: <any>[]
  },
  {
    id: 3,
    title: 'الوحدات',
    key: 'attributes',
    to: '/attributes',
    icon: { icon: 'mdi-counter' },
    subItems: <any>[]
  },

  {
    id: 5,
    title: 'العملاء',
    key: 'customers',
    to: '/customers',
    icon: { icon: 'mdi-account-group' },
    subItems: <any>[]
  },
  {
    id: 6,
    title: 'الطلبات',
    key: 'orders',
    icon: { icon: 'mdi mdi-cart-variant' },
    subItems: <any>[
      {
        id: 1,
        title: 'كل الطلبات ',
        key: 'orders',
        to: '/orders',
        icon: { icon: 'mdi mdi-cart-variant' }
      },
      {
        id: 2,
        title: 'تعديل سريع',
        key: 'orders',
        to: '/orders/quick-edit',
        icon: { icon: 'mdi mdi-pencil' }
      },
      {
        id: 2,
        title: 'الطلبات الجديدة ',
        key: 'orders',
        to: '/orders/new-orders',
        icon: { icon: 'mdi mdi-cart-check' }
      }
    ]
  },
  {
    id: 7,
    title: 'الكوبونات',
    key: 'coupons',
    to: '/coupons',
    icon: { icon: 'mdi-ticket-percent-outline' },
    subItems: <any>[]
  },
  {
    id: 8,
    title: 'التقارير',
    key: 'reports',
    to: '/reports',
    icon: { icon: 'mdi-file-chart-outline' },
    subItems: <any>[]
  },
  {
    id: 9,
    title: 'وسائل التوصيل',
    key: '',
    to: '/shipping/zones/0',
    icon: { icon: 'mdi mdi-truck' },
    subItems: <any>[]
  },
  {
    id: 10,
    title: 'المهملات',
    key: 'trah',
    to: '/trash',
    icon: { icon: 'mdi mdi-delete-variant' },
    subItems: <any>[]
  },
  {
    id: 11,
    title: 'الاعدادات',
    key: 'settings',
    to: '/settings',
    icon: { icon: 'mdi mdi-cog' },
    subItems: <any>[]
  },
  {
    id: 13,
    title: 'جدول المقاسات',
    key: '',
    to: '/size-charts',
    icon: { icon: 'mdi mdi-table' },
    subItems: <any>[]
  },
  {
    id: 12,
    title: 'التحديثات',
    key: 'updates',
    to: '/release-notes',
    icon: { icon: 'mdi mdi-update' }
  },
  {
    id: 13,
    title: 'أدوات مفيدة',
    key: 'tools',
    to: '/tools',
    icon: { icon: 'mdi mdi-wrench' },
    subItems: <any>[]
  },
  {
    id: 14,
    title: 'فحص تاريخ الميلاد',
    key: 'birthdays',
    to: '/birthdays',
    icon: { icon: 'mdi mdi-cake-variant' },
    subItems: <any>[]
  }
]

export default navigationItems
